import { Grid } from '@statsbomb/kitbag-components';
import { FULL_WIDTH_GRID, HALF_WIDTH_GRID } from '@/consts/grids';
import { entityVisualisationComponents } from '@/consts/widget';
import { Section } from '@/types/generic';
import { UserConfigWidgetDefinition } from '@/types/userConfigs';
import { WidgetVisType } from '@/types/widget';
import { DashboardWidgetWrapper } from '../widget/DashboardWidgetWrapper';

const WIDGET_WIDE_XL = 8;
const WIDGET_NARROW_XL = 4;

const isValidWidget = (entity: Section, vis: WidgetVisType) => !!entityVisualisationComponents[entity][vis];

const getXlColumns = (isNarrow: boolean, vis: WidgetVisType) => {
  if (isNarrow) return FULL_WIDTH_GRID;
  return vis === 'info' ? WIDGET_WIDE_XL : WIDGET_NARROW_XL;
};

export const DashboardWidgets = ({
  entityId,
  widgets,
  isNarrow = false,
}: {
  entityId: number;
  widgets: UserConfigWidgetDefinition[];
  isNarrow?: boolean;
}) => {
  const filteredWidgets = widgets.filter(({ definition }) => isValidWidget(definition.entity, definition.vis));

  return (
    <Grid>
      {filteredWidgets.map(({ configId, definition }) => (
        <Grid
          testId={configId}
          item
          md={FULL_WIDTH_GRID}
          lg={isNarrow ? FULL_WIDTH_GRID : HALF_WIDTH_GRID}
          xl={getXlColumns(isNarrow, definition.vis)}
          key={configId}
        >
          <DashboardWidgetWrapper key={configId} {...definition} widgetId={configId} entityId={entityId} />
        </Grid>
      ))}
    </Grid>
  );
};
